// extracted by mini-css-extract-plugin
module.exports = {"container":"slider-no-photo_container__fxtfP","header":"slider-no-photo_header__ZivNO","text":"slider-no-photo_text__S8BH4","button":"slider-no-photo_button__oKdpt"};